angular.module('promotionCodeAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate']);



// WEBPACK FOOTER //
// ./src/app/promotion-code-add/promotion-code-add.module.js